export const enum ExperimentGroupEnum {
  TEST = 'TEST',
  CONTROL = 'CONTROL',
  NONE = 'NONE',
}

export const EXPERIMENT_COOKIE = 'EXPERIMENTAL_GROUP';
